export default __webpack_public_path__ + "3b9d3503697a0db69be122d6ab000985.png";